<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('building_name')">
                            <b-form-input :validate-error="errors[0]" v-model="formData.name">
                            </b-form-input>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="address" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('address')">
                            <b-form-input :validate-error="errors[0]" v-model="formData.address">
                            </b-form-input>
                        </b-form-group>
                    </ValidationProvider>

                        <ValidationProvider name="cleaning_schedule_start_date" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('cleaning_schedule_start_date')">
                                <select-date  v-model="formData.cleaning_schedule_start_date"
                                             :validation-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>

                    <ValidationProvider name="cleaning_schedule_repeat" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('cleaning_schedule_repeat')">
                            <b-input-group class="mb-3">
                                <b-form-input
                                    v-model="formData.cleaning_schedule_repeat"
                                    type="number"
                                >
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="storeForm">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import HousingBuilding from "@/services/HousingBuildingServices";
import GenderSelectbox from "@/components/interactive-fields/GenderSelectbox.vue";
import moment from "moment";

export default {
    components: {
        GenderSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formData: {
                name: null,
                address: null,
                cleaning_schedule_start_date:null,
                cleaning_schedule_repeat:null
            },
        }
    },
    methods: {
        async storeForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.formData.cleaning_schedule_start_date = moment(this.formData.cleaning_schedule_start_date).format('MM/DD/YYYY')
                HousingBuilding.store(this.formData)
                    .then(response => {
                        this.$emit('createFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false
                    })
            }
        }
    }
}
</script>
